import {Text} from '@primer/react'

/** Visually hidden text that will still be read by a screen reader. Link with aria-describedby. */
export const HiddenDescription = ({children, id}: {children: React.ReactNode; id: string}) => (
  <Text className="sr-only" id={id} aria-live="polite">
    {children}
  </Text>
)

try{ HiddenDescription.displayName ||= 'HiddenDescription' } catch {}